import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import DashboardItem from "../base/DashboardItem";
import { useDispatch, useSelector } from "../../store";
import { setCurrentViewJobType } from "../../slices/jobType";
import {
  getJobCount,
  // getWeekHighlights
} from "../../slices/job";
import { Base } from "../base";
import WeeklyHighlights from "../views/Home/WeeklyHighlights";
import checkRole, { UserRoles } from "../../helpers/checkRole";

interface Props {}

const HomeDashboard: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const {
    jobCounts,
    status,
    //  weeklyHighlight
  } = useSelector((store) => store.job);
  const { loggedInUser } = useSelector((store) => store.authentication);
  const [weeklyDrawer, setWeeklyDrawer] = useState<boolean>(false);

  useEffect(() => {
    dispatch(setCurrentViewJobType(undefined));
    dispatch(getJobCount());
    // dispatch(getWeekHighlights());
  }, [dispatch]);

  return (
    <Container maxWidth="xl">
      {status === "loading" ? (
        <Grid
          container
          justifyContent={"center"}
          flexDirection={"column"}
          alignItems={"center"}
          my={3}
        >
          <CircularProgress size={75} />
          <Typography>Loading, please wait...</Typography>
        </Grid>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            py: { sm: 5, xs: 2 },
            gap: 5,
          }}
        >
          {/* TODO Add back after updating and only show if any of the job types have a weekly highlight question in them */}
          {/* <Box sx={{ alignSelf: "flex-end" }}>
            <Base.Button
              text="View Weekly Tasks"
              onClick={() => setWeeklyDrawer(true)}
              disabled={
                !weeklyHighlight.sunday.length &&
                !weeklyHighlight.monday.length &&
                !weeklyHighlight.tuesday.length &&
                !weeklyHighlight.wednesday.length &&
                !weeklyHighlight.thursday.length &&
                !weeklyHighlight.friday.length &&
                !weeklyHighlight.saturday.length
              }
            />
          </Box> */}
          {/* TODO: REARRANGE AND REWORK HOW JOBTYPES ARE DISPLAYED ON THIS PAGE */}
          <Grid
            container
            direction={"row"}
            justifyContent={"center"}
            spacing={5}
          >
            {jobCounts.length ? (
              jobCounts.map((jt) => {
                return (
                  <Grid size={{ md: 3, sm: 6, xs: 10 }} key={jt.jobType.id}>
                    <DashboardItem
                      jobType={jt.jobType}
                      statusCounts={jt?.statusCounts}
                      closedTotal={jt?.recentComplete}
                      loading={false}
                    />
                  </Grid>
                );
              })
            ) : (
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Base.Text
                    text="No Job Types to display"
                    center
                    variant="h3"
                  />
                </Grid>
                <Grid size={12}>
                  {checkRole(loggedInUser!, UserRoles.GlobalAdmin) ||
                  checkRole(loggedInUser!, UserRoles.GmdAdmin) ? (
                    <Base.Text
                      text="Assign yourself Job Types on the Users tab in Settings"
                      center
                      variant="h3"
                    />
                  ) : (
                    <Base.Text
                      text="Contact your system admin to be assigned Job Types"
                      center
                      variant="h3"
                    />
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
          <WeeklyHighlights
            open={weeklyDrawer}
            setWeeklyDrawer={setWeeklyDrawer}
          />
        </Box>
      )}
    </Container>
  );
};

export default HomeDashboard;
